"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERoomCount = void 0;
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
let ERoomCount = exports.ERoomCount = /*#__PURE__*/function (ERoomCount) {
  /** Четырехкомнатная квартира **/
  ERoomCount["FourRoom"] = "fourRoom";
  /** Однокомнатная квартира **/
  ERoomCount["OneRoom"] = "oneRoom";
  /** Студия **/
  ERoomCount["Studio"] = "studio";
  /** Трехкомнатная квартира **/
  ERoomCount["ThreeRoom"] = "threeRoom";
  /** Двухкомнатная квартира **/
  ERoomCount["TwoRoom"] = "twoRoom";
  return ERoomCount;
}({});